import create from './create';
import Activity from './model';

Activity.create = create;

export default Activity;



// WEBPACK FOOTER //
// ./data/WritingAssignment/Activity/index.js